import axios from "axios";
import AuthService from "../AuthService";
import urlBase from "../UrlBaseUtil";

/** @param {AxiosRequestConfig} config */
function applyAuthHeaders(config) {
  config.headers.Authorization = `Bearer ${AuthService.getToken()}`;
  return config;
}
/** Client to use for new API. Use `AuthRequest` for the legacy API calls. */
export const AuthClient = axios.create({
  baseURL: urlBase.getApiBase(),
});
AuthClient.interceptors.request.use(applyAuthHeaders);

/** Native fetch wrapper with AuthClient's base URL and auth headers. Supports streaming responses. */
export function authFetch(path, data, { signal } = {}) {
  const url = `${urlBase.getApiBase().replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
  return fetch(url, {
    method: data ? "POST" : "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${AuthService.getToken()}`,
    },
    body: data ? JSON.stringify(data) : undefined,
    signal,
  });
}

export default AuthClient;
